module.exports = __webpack_public_path__ + "img/icon-upload-file.690a32a7.svg";